import React, { useState } from 'react'
import { Breadcrumb, Button, Card, Row, Col } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faEdit, faExclamation, faHome, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Form, Input, Modal, Button as AntButton, Table, Space, Tag, Upload, Select, Empty, Tooltip } from 'antd';
import { InboxOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { activateListItems, createListItems, createPayFeature, deleteListItems, updateListItems } from '../../../services/apiCalls';
import AlertToast from '../../../components/AlertToast';
// import { featureAlert, featureResponse, features, homePage, homeRefresh } from '../../../states/home';
import { dummyRequest, getHtml } from '../../../services/utilities';
import { imageUrl } from '../../../services/axios';
import PayCard from './PayCard';
import PayListCard from './PayListCard';
import { featureAlert, featureResponse, payRefresh, payPage } from '../../../states/wayaPay';
import { Editor } from 'react-draft-wysiwyg';
// import MediaCard from './MediaCard';

const WayaPay = () => {
  // const data = useRecoilValueLoadable(features)
  const data = useRecoilValue(payPage)
  const [viewModal, setViewModal] = useState(false)
  const [viewModal2, setViewModal2] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState({})
  const [file, setFile] = useState("")
  const [editor, setEditor] = useState("")
  const [editorDesc, setEditorDesc] = useState("")
  const [showAlert, setShowAlert] = useRecoilState(featureAlert);
  const [response, setResponse] = useRecoilState(featureResponse)
  const [uploadImage, setUploadImage] = useState(false)
  const [desc, setDesc] = useState(false)
  const [ben, setBen] = useState(false)
  const setRefresh = useSetRecoilState(payRefresh)
  const [form] = Form.useForm()
  const { confirm } = Modal;
  const payCall = data?.data && data?.data
  const { bank, business, integrate, benefit, services, download, products } = payCall ? payCall : []
  const featureList = data?.homeFeatures
  const unique = featureList && featureList.filter(f => f.type == "unique")
  const { Option } = Select;

  const columns = [
    {
      title: 'Image',
      dataIndex: 'image_url',
      key: 'image_url',
      render: text => <img alt="features" src={text} />
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Desc Title',
      dataIndex: 'sub_title',
      key: 'sub_title',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: text => <Tag color={text === 1 ? "#2db7f5" : "#f50"}>{text ? "Show" : "Hide"}</Tag>
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => {
        const action = (record.status ===1 ? 'Hide' : 'Show')
        return (
          <Space size="small">
          <Tooltip title='Edit'>
            <AntButton type="ghost" onClick={() => handleUpdateModal(record)}>
              <FontAwesomeIcon icon={faEdit} />
            </AntButton>
          </Tooltip>
            {action === 'Hide'?
            <Tooltip title='Deactivate'>
              <AntButton type="danger" onClick={() => showAction(id, action)}>
                <FontAwesomeIcon icon={faTimes} />
              </AntButton>
            </Tooltip>:            
            <Tooltip title='Activate'>
              <AntButton type="primary" onClick={() => confirmAction(id, action)}>
                <FontAwesomeIcon icon={faCheckSquare} />
              </AntButton>
            </Tooltip>
            }            
            <Tooltip title='Delete'>
              <AntButton type="danger" onClick={() => deleteAction(id)}>
                <FontAwesomeIcon icon={faTrash} />
              </AntButton>
            </Tooltip>
          </Space>
        )
      },
    },
  ];
  const confirmAction = (id, action) => {
    const data = {status: 1}
    confirm({
      title: `Are you sure you want to ${action} this Product?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data,)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  const showAction = (id, action) => {
    const data = {status: 0}
    confirm({
      title: `Are you sure you want to ${action} this Product?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data,)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleShowHide = async (id, type) => {
    console.log(type, id)
    const date = new Date()
    const res = await activateListItems({ data:type, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };

  const onFinish = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    // fd.append('title', val.title)
    // fd.append('description', val.description)
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    fd.append('google_url', val.google_url)
    fd.append('app_store_url', val.app_store_url)
    fd.append('get_start_url', val.get_start_url)
    fd.append('position', val.position)
    fd.append('parent_id', val.parent_id)
    fd.append('type', val.type)
    fd.append('file', file);
    const res = await createPayFeature(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewModal(false)
      form.resetFields()
      setFile('')
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
    }
    setLoading(false)
    form.resetFields()
  }
  const onFinish2 = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', val.title)
    fd.append('description', val.description)
    fd.append('type', val.type)
    fd.append('sub_title', val.sub_title)
    fd.append('file', file);
    const res = await createListItems(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewModal2(false)
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
    }
    setLoading(false)
    form.resetFields()
  }

  const onFinishUpdate = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', val.title)
    fd.append('description', val.description)
    fd.append('sub_title', val.sub_title)
    fd.append('file', file);
    try {
      const res = await updateListItems({ data: fd, id:val.id })
      if (res.status) {
        setResponse({ message: res.message, title: "success" })
        setShowAlert(true)
        setRefresh(date.toTimeString())
        setEditModal(false)
        setFile()
      } else {
        setResponse({ message: res.message || res, title: "failed" })
        setShowAlert(true)
        setFile()
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
    setFile()
  }

  const handleUpdateModal = (val) => {
    setEditModal(true)
    setValue(val)
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };
  const deleteAction = (id) => {
    confirm({
      title: `Are you sure you want to delete this Post?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDeleteList(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDeleteList = async (id) => {
    const date = new Date()
    const res = await deleteListItems(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  const onChange = (v) => {
    console.log(v)
    if (v === "section6") { 
      setBen(false)
    } else { 
      setBen(true) 
    }
  }
  return (
    <div>
      <AlertToast showAlert={showAlert} setShowAlert={setShowAlert} response={response} page="Home" />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Waya pay</Breadcrumb.Item>
            <Breadcrumb.Item active>Pay-Waya</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Waya-Pay Page</h4>
        </div>
        <div className="table-settings mb-4">
          <Button variant="success" className="text-white me-3" onClick={() => setViewModal(true)}>
            Create New Feature <FontAwesomeIcon icon={faHome} className="d-none d-sm-inline ms-1" />
          </Button>
        </div>
      </div>
      <h4>Waya-Pay Home</h4>
      {bank &&
      bank.length === 0 ? <Empty />:
      bank && bank.map(dat =>
        <PayCard key={dat.id} featureImg={true} img={dat.image_url} description={dat.description} title={dat.title} 
          type="bank" id={dat.id} link={true} status={dat.status} url="/admin/home_page/hero" name='Home Feature'
          google_url={dat.google_url} app_url={dat.app_url} get_start_url={dat.get_start_url} position={dat.position}
        />
      )}
      <Row>
        <h4>Waya-Pay Section 2</h4>
        {business &&
        business.length === 0 ? <Empty />:
        business && business.map(ex =>
          <PayCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="product" id={ex.id} status={ex.status} link_url={ex.link_url} name='Product & Services'
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
        )}
      </Row>
      <Row>
        <h4>Waya-Pay Section 3</h4>
        {products && 
        products.length === 0 ? <Empty />:
        products && products.map(ex =>
          <PayCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="product" id={ex.id} status={ex.status} link_url={ex.link_url} name='Product & Services'
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
        )}
      </Row>
      <Row>
        <h4>Waya-Pay Section 4</h4>
        {services && 
        services.length === 0 ? <Empty />:
        services && services.map(ex =>
          // <Col xs={12} xl={4} lg={4} key={ex.id}>
          <PayCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} type="POS" id={ex.id}   
            status={ex.status} link_url={ex.link_url} name='Sales Point'
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
          // </Col>
        )}
      </Row>
      <Row>
        <h4>Waya-Pay Section 5</h4>
        {benefit && 
        benefit.length === 0 ? <Empty />:
        benefit && benefit.map(ex =>
          // <Col xs={12} xl={4} lg={4} key={ex.id}>
          <PayListCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="POS" id={ex.id} status={ex.status} link_url={ex.link_url} name='Sales Point' 
            desc={true} ben={false} uploadImage={false} listItem={ex.listItem} featureImg={true}
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
          // </Col>
        )}
      </Row>
      <Row>
        <h4>Waya-Pay Section 6</h4>
        {integrate && 
        integrate.length === 0 ? <Empty />:
        integrate && integrate.map(ex =>
          // <Col xs={12} xl={4} lg={4} key={ex.id}>
          <PayListCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="POS" id={ex.id} status={ex.status} link_url={ex.link_url} name='Sales Point' 
            desc={true} ben={false} uploadImage={false} listItem={ex.listItem} featureImg={false}
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
          // </Col>
        )}
      </Row>
      <Row>
        <h4>Waya-Pay Download</h4>
        {download && 
        download.length === 0 ? <Empty />:
        download && download.map(ex =>
          // <Col xs={12} xl={4} lg={4} key={ex.id}>
          <PayCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title}  type="POS" id={ex.id}
             status={ex.status} link_url={ex.link_url} name='Sales Point'
             google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          /> 
          // </Col>
        )}
      </Row>


      {/*create feature start */}
      <Modal
        title="Create New Feature"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item label="Type" name="type" rules={[{ required: true }]}>
            <Select onChange={onChange}>
              <Option key='1' value="section1">Waya-Pay Home</Option>
              <Option key='2' value="section2">Waya-Pay Section 2</Option>
              <Option key='3' value="section3">Waya-Pay Section 3</Option>
              <Option key='4' value="section4">Waya-Pay Section 4</Option>
              <Option key='5' value="section5">Waya-Pay Section 5</Option>
              <Option key='6' value="section6">Waya-Pay Section 6</Option>
              <Option key='7' value="section7">Waya-Pay Download</Option>
              {/* <Option value="t-pos">Terminal Pos</Option>
              <Option value="amazing">Amazing Feature</Option> */}
            </Select>
          </Form.Item>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
            <Form.Item label="Description" name="description">
              {/* <Input.TextArea /> */}
              <Editor
                editorState={editorDesc}
                editorClassName="px-3 border border-gray-1"
                editorStyle={{
                  height: 100,
                  overflow: 'auto',
                }}
                onEditorStateChange={onEditorStateChanges}
              />
            </Form.Item>
            <Form.Item label="Position" name="position">
              <Input type='number' />
            </Form.Item>
            {/* {ben && */}
            <Form.Item label="Google Play Link" name="google_url">
              <Input />
            </Form.Item>
            <Form.Item label="App Store Link" name="app_url">
              <Input />
            </Form.Item>
            <Form.Item label="Get Started Link" name="get_start_url">
              <Input />
            </Form.Item>
            {/* } */}
          {/* {ben && */}
            <Form.Item >
              <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
              </Upload>
            </Form.Item>
          {/* } */}
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Create
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/*create feature end */}

    {/*create Product start */}
      <Modal
        title="Create New Product Feature"
        centered
        visible={viewModal2}
        footer={null}
        onCancel={() => setViewModal2(false)}
      >
        <Form form={form} onFinish={onFinish2} layout="vertical">
          <Form.Item label="Type" hidden initialValue='product' name="type" rules={[{ required: true }]}>
            <Input hidden />
          </Form.Item>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Desc Title" name="sub_title">
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description">
            <Input.TextArea />
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Create
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/*create feature end */}

      {/* update feature start */}
      <Modal
        title="Update Feature"
        centered
        visible={editModal}
        footer={null}
        onCancel={() => setEditModal(false)}
      >
        <Form form={form} onFinish={onFinishUpdate} layout="vertical" initialValues={{ title: value.title, description: value.description, id: value.id, image_url: value.image_url, sub_title: value.sub_title }}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Desc Title" name="sub_title">
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description">
            <Input.TextArea />
          </Form.Item>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/* update feature end */}
    </div>
  )
}

export default WayaPay
